// frontend\src\components\Footer.js
import { APP_NAME, APP_VERSION } from '../constants';

const Footer = () => {
    return (
        <footer className="bg-dark text-light text-center py-3 mt-auto">
            <div className="container">
                <p className="mb-0">
                    {APP_NAME} &copy; {new Date().getFullYear()} | Версия: {APP_VERSION}
                </p>
            </div>
        </footer>
    );
};

export default Footer;